module.exports = __webpack_public_path__ + "img/car6.7db63726.png";